var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPaperJamA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#f9e6c9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 144,
    height: 144
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.14,68.1l-11.91,38.11-21.33-80a3,3,0,0,0-5.75-.18L62,74.62,56.4,67.2l-4.8,3.6,9,12A3,3,0,0,0,65.85,82L80.68,37.44l21.42,80.33a3,3,0,0,0,2.84,2.23H105a3,3,0,0,0,2.86-2.1L122.21,72H132V66H120A3,3,0,0,0,117.14,68.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54,51A21,21,0,1,0,33,72,21,21,0,0,0,54,51ZM33,66A15,15,0,1,1,48,51,15,15,0,0,1,33,66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,72A21,21,0,1,0,54,93,21,21,0,0,0,33,72Zm0,36A15,15,0,1,1,48,93,15,15,0,0,1,33,108Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPaperJamA);
export default __webpack_public_path__ + "static/media/img_PaperJam_a.e3dd77f4c011c9e7f4b4126a5190f12b.svg";
export { ForwardRef as ReactComponent };